var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 16a3.067 3.067 0 01-1.04 2.305L10.091 31.386a2.462 2.462 0 01-3.251-3.698l13.003-11.439a.334.334 0 000-.501L6.84 4.309A2.463 2.463 0 0110.092.611l14.864 13.077a3.079 3.079 0 011.045 2.309z"
  })));
}
export default SvgArrowRight;